import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LL_V_L, ModuleFE_Dialog, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import './Dialog_ClearEncounterDialog.scss';
// @ts-ignore
import QuaiLogo from './quai-image.svg';
import { ModuleFE_AdvisorWindowMessenger } from '@app/advisor-frontend';
export class Dialog_ClearEncounter extends TS_Dialog {
    static defaultProps = {
        dialogId: 'clear-encounter'
    };
    static show(message) {
        return ModuleFE_Dialog.show({
            content: _jsx(Dialog_ClearEncounter, { message: message }),
            closeOverlayOnClick: () => false,
            overlayClass: 'blur',
        });
    }
    render() {
        return _jsxs(LL_V_L, { className: 'advisor-clear-encounter-dialog', children: [_jsx("img", { src: QuaiLogo, alt: "quai-web", className: 'img' }), _jsx("div", { className: 'title', children: this.props.message }), _jsx("div", { className: 'text', children: "Click the button below to close the app" }), _jsx(Button, { onClick: () => ModuleFE_AdvisorWindowMessenger.closeActivity({}), variant: 'primary', children: "Close App" })] });
    }
}
//# sourceMappingURL=Dialog_ClearEncounterDialog.js.map